import { NgModule } from '@angular/core';
import { RotateSchemasRepositoryComponent} from './rotate-schemas-repository.component'

import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared';
import { CommonModule } from '@angular/common'
import { MatSelectModule } from '@angular/material/select'
import {SchemaItemModule} from '../../../../schema-item/schema-item.module'

@NgModule({
    imports: [ FormsModule,SharedModule, CommonModule,MatSelectModule,SchemaItemModule],
    declarations: [
        // EnvironmentItemComponent,
        RotateSchemasRepositoryComponent
    ],
    entryComponents: [
        RotateSchemasRepositoryComponent
    ],
    exports: [
        RotateSchemasRepositoryComponent
    ]
})
export class rotateSchemasRepositoryModule {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/rotatorItem/rotate-schemas-repository/rotate-schemas-repository.module.ts